/**
 * Release stage.
 *
 * The app is in beta: the data model is still moving, so there is a way to wipe
 * the database and start clean rather than machinery to migrate every shape it
 * has passed through. That escape hatch has no place in a live build, where a
 * stray click would cost someone their library — so the gate lives here, in one
 * named place, rather than scattered as `import.meta.env.DEV` checks that would
 * also disappear from a beta build served to a phone.
 *
 * Build with `VITE_RELEASE_STAGE=live` to drop it.
 */

export type ReleaseStage = 'beta' | 'live';

export const RELEASE_STAGE: ReleaseStage =
  import.meta.env.VITE_RELEASE_STAGE === 'live' ? 'live' : 'beta';

export const isBeta = (): boolean => RELEASE_STAGE === 'beta';
